"use strict";

const FactSheetNew = function () {
  let config;
  let $container;
  let data;
  let currentId;
  let currentCompositeId;
  const searchStrings = new Map();

  var open = async function (
    id,
    _config = null,
    _data = null,
    { highlightId = null, compositeId = null } = {},
  ) {
    config?.onCloseFunction?.();
    if (_config) _init(_config);
    config.onCloseFunction?.();
    currentId = id;
    currentCompositeId = compositeId;
    if (!(await _getData(id, _data))) {
      close();
      return;
    }
    _setDataSort();
    _show();
    _addMap();
    _loadListeners();
    _handleFilterFlow();
    _rerenderAllTables();
    FactSheetPhotos.init(config, data, $container);
    config.afterOpenFunction?.();
    if (highlightId) {
      highlightElement($container.find(`#${highlightId}`));
    }
    SideBar.highlightRow(_getRenderedId());
  };

  var _getRenderedId = function () {
    return currentCompositeId ?? Number(currentId);
  };

  var reload = function (_data) {
    if (_data) {
      if (_data.id !== currentId) return;
      _data = { ...data, ..._data };
    }
    open(currentId, null, _data, { compositeId: currentCompositeId });
  };

  var _init = function (_config) {
    config = _config;
    $container = $("#fact-sheet-container");
  };

  var _setDataSort = function () {
    if (!Tree.get("factSheet", "open")) {
      Filters.setDataSort(DataViewFunctions.getCurrentDataViewProperty("flatDataSort"));
    }
  };

  var _addMap = function () {
    if ($("#factsheet-map").length === 0) {
      return;
    }

    const polygon = data[config.polygonColumnName];
    const point = data[config.pointColumnName];
    const icon = config.iconFunction(data);

    if (polygon) {
      MapFunctions.createStaticMapWithPolygon("factsheet-map", { geom: polygon });
    } else if (point) {
      MapFunctions.createStaticMapWithPoint("factsheet-map", { geom: point, icon });
    }
  };

  var _handleFilterFlow = function () {
    Table.renderBackButtonIfFactSheet();
    SmartFilterRegistry.getSummary()?.disable?.();
  };

  var _getData = async function (id, _data = null) {
    const newData = _data || (await config.getDataFunction(id));
    if (newData?.status === 404) return false;
    data = {
      ...newData,
      isFullWidth: !(Tree.get("activeTab") === "data"),
      searchStrings: Object.fromEntries(searchStrings.entries()),
      tableWasOpen: data?.tableWasOpen ?? !$("body").hasClass("no-table"),
      previousDataSort: Tree.get(["table", "dataSort"]),
      $activeMapPage: data?.$activeMapPage ?? $("#map-pages").children(".active"),
    };
    config.prepareDataFunction?.(data);
    return true;
  };

  var _show = function () {
    const scrollPosition = $(".fact-sheet").scrollTop();
    $container.html(nunjucks.render(config.template, data));
    $(".fact-sheet").scrollTop(scrollPosition);

    Tree.set(["factSheet", "open"], true);
    Tree.set(["factSheet", "id"], _getRenderedId());
    $("#map-pages").children().removeClass("active");
    $("body").toggleClass("no-table", data.isFullWidth);
    $container.addClass("active");
    ReportingTimelineController.hide();
  };

  var _loadListeners = function () {
    $("#bottomFloatingInputsTable")
      .off("click", ".table-datum", _onClickTableDatum)
      .on("click", ".table-datum", _onClickTableDatum)
      .off("click", ".ms4-return-button")
      .on("click", ".ms4-return-button", close);
    $container
      .off("click", ".back-button", close)
      .on("click", ".back-button", close)
      .off("click", ".toggle-show-more", _toggleShowMore)
      .on("click", ".toggle-show-more", _toggleShowMore)
      .off("input", ".fact-sheet-search-table", _inputSearchTable)
      .on("input", ".fact-sheet-search-table", _inputSearchTable)
      .off("click", "th.sortable", _sortByClickedColumn)
      .on("click", "th.sortable", _sortByClickedColumn)
      .off("click", "#fact-sheet-next", _clickNext)
      .on("click", "#fact-sheet-next", _clickNext)
      .off("click", "#fact-sheet-previous", _clickPrevious)
      .on("click", "#fact-sheet-previous", _clickPrevious)
      .off("click", ".download-site-map", _downloadSiteMap)
      .on("click", ".download-site-map", _downloadSiteMap)
      .off("click", ".map-button", _goToMap)
      .on("click", ".map-button", _goToMap);
  };

  var _goToMap = function () {
    const id = _getRenderedId();
    const goToMapFunction = config?.goToMapFunction;
    close();
    MapFunctions.openPopupById(id);
    goToMapFunction?.();
  };

  var _onClickTableDatum = function () {
    _go($(this).data("id"));
  };

  var _go = function (id) {
    if (!Tree.get(["factSheet", "open"]) || !id) return;
    const routeName = DataViewFunctions.getCurrentDataViewProperty("factSheetRouteName");
    UrlRoutes.go(routeName, { id });
  };

  var closeIfId = function (id) {
    if (id === currentId) close();
  };

  var close = function () {
    if (config) {
      UrlRoutes.navigate(config.closeUrl);
      config.onCloseFunction?.();
    }
    if (!Tree.get(["factSheet", "open"])) return;

    Filters.setDataSort(data.previousDataSort, true, false);
    Tree.set(["factSheet", "open"], false);
    $("#fact-sheet-container").removeClass("active");
    $("body").toggleClass("no-table", data.tableWasOpen === false);
    data.$activeMapPage.addClass("active");
    Table.renderBackButtonIfFactSheet();

    if (Tree.get("activeTab") === "todo") {
      ReportingTimelineController.show();
    }

    if (Tree.get("navToggleSelection") === "map") {
      MainMap.invalidateMapSize();
    }

    data = null;
  };

  var _toggleShowMore = function (e) {
    $(this).closest(".factsheet-table").toggleClass("expanded");
    e.preventDefault();
  };

  var _inputSearchTable = function () {
    _searchTable($(this).data("table-key"));
  };

  var _searchTable = function (tableKey) {
    const search = $(`input[data-table-key="${tableKey}"]`).val() || "";
    searchStrings.set(tableKey, search);
    const searchSelector = `${_tableSelector(tableKey)} tbody tr`;
    FilterDom.filterByText(search, $(searchSelector));
  };

  var _rerenderTable = function (key) {
    const $table = $(_tableSelector(key));
    const template = config.tableTemplates[key];
    const sortedData = { [key]: _getSortedData(key) };
    $table.find("tbody").html(nunjucks.render(template, sortedData));
    _searchTable(key);
    TableSort.updateHeaders(config.dataSorting[key], $table);
  };

  var _tableSelector = function (key) {
    return `.factsheet-table[data-table-key="${key}"]`;
  };

  var _getSortedData = function (tableKey) {
    const sortedData = data[tableKey] || [];
    const sorting = config.dataSorting[tableKey];
    if (Object.keys(config?.sortersDict || {}).includes(sorting.key)) {
      SortUtilities.sortRows(sorting.key, sorting.reversed, sortedData, config.sortersDict);
    }

    return sortedData;
  };

  var _sortByClickedColumn = function () {
    const $this = $(this);
    const $table = $this.closest(".factsheet-table");
    const tableKey = $table.data("tableKey");
    config.dataSorting[tableKey] = {
      key: $this.data("sortKey"),
      reversed:
        config.dataSorting[tableKey]?.key === $this.data("sortKey")
          ? !config.dataSorting[tableKey]?.reversed
          : false,
    };
    _rerenderTable(tableKey);
  };

  function _getNextPrevRow(isNext) {
    const selector = ".table-datum:visible";
    const selectedRow = $(`.table-datum.map-hover`);
    const targetRow = isNext
      ? selectedRow.nextAll(selector).first()
      : selectedRow.prevAll(selector).first();
    return targetRow.length ? targetRow : isNext ? $(selector).first() : $(selector).last();
  }

  var _clickNext = function () {
    const $row = _getNextPrevRow(true);
    _go($row.data("id"));
  };

  var _clickPrevious = function () {
    const $row = _getNextPrevRow(false);
    _go($row.data("id"));
  };

  var _downloadSiteMap = function () {
    config.downloadSiteMapFunction(currentId);
  };

  var _rerenderAllTables = function () {
    Object.keys(config?.tableTemplates || {}).forEach((key) => _rerenderTable(key));
  };

  var getId = function () {
    return currentId;
  };

  var getData = function () {
    return data;
  };

  var $getRow = function ($this) {
    return $this.parents(".history-item-tr");
  };

  var addDisplayDates = function (data = []) {
    data.forEach(function (row) {
      if (!row.date) return;
      row.displayDate = DateTime.dateToGroupDisplayDate(DateTime.parseIsoDate(row.date));
    });
  };

  var highlightElement = function ($element) {
    $element.addClass("highlight-field");
    $element[0].scrollIntoView({ behavior: "smooth", block: "center" });
  };

  var addAbsoluteUrlsToFiles = function (files) {
    return files?.map((file) => {
      const makeAbsolute = file.externalUrl && !/^(https?:)?\/\/.*$/.test(file.externalUrl);
      file.absoluteUrl = makeAbsolute ? "//" + file.externalUrl : file.externalUrl;
      return file;
    });
  };

  return {
    open,
    close,
    closeIfId,
    getId,
    reload,
    getData,
    $getRow,
    addDisplayDates,
    addAbsoluteUrlsToFiles,
  };
};

module.exports = FactSheetNew();

const DataViewFunctions = require("../dataViewFunctions");
const DateTime = require("../dateTime");
const SideBar = require("../esg/sideBar");
const SmartFilterRegistry = require("../filters/smartFilterRegistry");
const Filters = require("../mapFunctions/filters");
const SortUtilities = require("../general/sortUtilities");
const MapFunctions = require("../mapFunctions/mapFunctions");
const Table = require("../mapFunctions/table");
const UrlRoutes = require("../routes/urlRoutes");
const Tree = require("../tree");
const FilterDom = require("./filterDom");
const TableSort = require("./tableSort");
const FactSheetPhotos = require("./factSheetPhotos");
const ReportingTimelineController = require("../reportingTimelineController");
const MainMap = require("../mapFunctions/mainMap");
